export default "__VITE_ASSET__DQQ6zVlG__"